import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const postsService = {
  getPosts: async (password) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/admin-posts/${password}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data;
  },

  updatePost: async (formdata) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/admin-update-post`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(formdata),
    });
    const data = await response.json();
    return data;
  },
};

export default postsService;
